<template>
  <div class="modal proposal-link-view-modal animated fadeIn" :class="{ 'is-active': $route.path.indexOf('/document-link') > -1 }">
    <div class="modal-background"></div>
    <comments-float :payload="payload"></comments-float>

    <div class="modal-card animated fadeInUp">

      <loading-indicator v-if="!documentLoaded"></loading-indicator>

      <document-part-cover :payload="payload" v-if="documentLoaded && !deadLink" state="view"></document-part-cover>

      <div class="document" v-if="documentLoaded  && !deadLink">
        <div v-for="(part, key) in payload.body" :key="part.id">
          <div class="columns">
            <div class="column is-10 is-offset-1">
              <div class="part-wrapper">
                <document-part-h1 v-if="part.type === 'h1'" :part="part" state="view"></document-part-h1>
                <document-part-h2 v-if="part.type === 'h2'" :part="part" state="view"></document-part-h2>
                <document-part-h3 v-if="part.type === 'h3'" :part="part" state="view"></document-part-h3>
                <document-part-text v-if="part.type === 'text'" :part="part" state="view"></document-part-text>
                <document-part-bulleted-list v-if="part.type === 'bulleted-list'" :part="part" state="view"></document-part-bulleted-list>
                <document-part-numbered-list v-if="part.type === 'numbered-list'" :part="part" state="view"></document-part-numbered-list>
                <document-part-image v-if="part.type === 'image'" :part="part" state="view"></document-part-image>
                <document-part-table v-if="part.type === 'table'" :part="part" state="view"></document-part-table>
                <document-part-module v-if="part.type === 'module'" :part="part" state="view"></document-part-module>
                <document-part-pricing-table v-if="part.type === 'pricing-table'" :part="part" state="view"></document-part-pricing-table>
                <document-part-page-break v-if="part.type === 'page-break'" state="view"></document-part-page-break>
                <document-part-initials v-if="part.type === 'initials'" :signatures="signatures" :part="part" state="view"></document-part-initials>
                <document-part-signatures v-if="part.type === 'signatures'" :signatures="signatures" :part="part" :viewer="viewer" state="view"></document-part-signatures>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import API from 'mixins/api';
  import { analytics } from 'mixins/analytics';
  import CommentsFloat from 'components/partials/comments-float.vue';
  import draggable from 'vuedraggable';
  import DocumentPartCover from '../document-parts/cover.vue';
  import DocumentPartText from '../document-parts/text.vue';
  import DocumentPartH1 from '../document-parts/h1.vue';
  import DocumentPartH2 from '../document-parts/h2.vue';
  import DocumentPartH3 from '../document-parts/h3.vue';
  import DocumentPartBulletedList from '../document-parts/bulleted-list.vue';
  import DocumentPartNumberedList from '../document-parts/numbered-list.vue';
  import DocumentPartImage from '../document-parts/image.vue';
  import DocumentPartTable from '../document-parts/table.vue';
  import DocumentPartPageBreak from '../document-parts/page-break.vue';
  import DocumentPartPricingTable from '../document-parts/pricing-table.vue';
  import DocumentPartSignatures from '../document-parts/signatures.vue';

  export default {
    mixins: [API, analytics],
    components: {
      CommentsFloat,
      DocumentPartCover,
      DocumentPartText,
      DocumentPartH1,
      DocumentPartH2,
      DocumentPartH3,
      DocumentPartBulletedList,
      DocumentPartNumberedList,
      DocumentPartImage,
      DocumentPartTable,
      DocumentPartPageBreak,
      DocumentPartPricingTable,
      DocumentPartSignatures,
    },
    data() {
      return {
        contact: {},
        comments: [],
        payload: false,
        signatures: false,
        documentLoaded: false,
        viewer: false, // ID and type of viewer (1/user, 2/contact)
        deadLink: false
      }
    },
    mounted() {
      this.fetchProposal();
    },
    methods: {
      goBack() {
        window.history.back();
      },
      fetchProposal() {
        return this.api().fetchDocumentByLink(this.$route.params.guid)
          .then(document => {
            this.payload = document.document;
            this.contact = document.contact;
            this.signatures = document.document.signatures;
            this.viewer = document.recipient;

            // Set some document analytics values
             this.startAnalytics(document);

            if (document.recipient.hasOwnProperty('company')) {
              window.userPing.pingAsContact(document.recipient.id);
            }

            window.viewer = this.viewer;
            this.documentLoaded = true;
          }).catch(e => {
            this.deadLink = true;
            this.documentLoaded = true;

            window.Events.$emit('alertModal', {
              'title': "This link is no longer active",
              'dismiss': false,
              'body': "This document has been edited or deleted. Please use an updated link or contact the document owner.",
              'actions': [],
              'done': {}
            });
          });
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "resources/assets/sass/layout/_variables";

  .document {
    width: 850px;
  }

  .fadeIn {
    animation-duration: 500ms;
  }
  .fadeInUp {
    animation-duration: 500ms;
  }

  .modal-background {
    background: darken($eggshell, 2%);
    position: fixed;
  }

  .modal {
    .modal-card {
      background: $white;
      border-radius: 2px;
      align-self: flex-start;
      margin-top: 100px;
      max-height: calc(200vh);
      overflow-y: auto;
      box-shadow: 0 2px 13px 1px rgba(211,215,221,0.50);
      .modal-card-head,
      .modal-card-foot {
        border-color: $white;
        background: $white;
      }
      .modal-card-head {
        padding: 40px;
        .modal-card-title {
          text-transform: uppercase;
          letter-spacing: 1px;
          font-weight: 600;
          font-size: 16px;
        }
      }
      .modal-card-body {
        padding: 0 40px;
      }
      .modal-card-foot {
        text-align: center;
        display: block;
        padding: 8px 40px 40px;
      }
    }
    .delete {
      top: 20px;
      right: 20px;
      position: fixed;
    }
    &.is-active {
      overflow: scroll;
      display: flex;
    }
  }

  .proposal-link-view-modal {
    .modal-card {
      background: none;
      margin-top: 0;
      width: 60%;
      margin-left: 6%;
      margin-right: 6%;
      overflow: visible;
      box-shadow: none;
      .fluid-label {
        width: 100%;
        margin-bottom: 0;
        padding: 10px 0;
        display: flex;
        flex-direction: row;
        span {
          font-weight: 700;
          font-size: 15px;
          text-transform: uppercase;
          letter-spacing: 1px;
          color: $purple;
          width: 16%;
          padding: 10px 0;
        }
        input {
          font-size: 17px;
          border-bottom: none;
          width: 84%;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// document-link-view-modal.vue?88ab6628